import Preloader from '../../Common/Preloader/Preloader'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'AddEmployee',
  components: { Preloader },
  data() {
    return {
      personalInn: '',
      orgInn: '',
      organisationName: '',
      employeeName: '',
      pinCode: '',
      isAdmin: false,
      isAlert: false,
      alertText: '',
      showPermissionsBlock: true,
      isEditOrgName: false,
      isEditEmployeeName: false,
      showPinCodeForm: false,
      isPreloader: true,
      error: false,
      errorMessage: '',
      orgInnRules: [
        v => !!v || 'Необходимо ввести ИНН организации',
        v => (v && v.length > 13) || 'ИНН организации должен быть равен 14 цифрам'
      ],
      personalInnRules: [
        v => !!v || 'Необходимо ввести ИНН сотрудника',
        v => (v && v.length > 13) || 'ИНН сотрудника должен быть равен 14 цифрам'
      ],
      orgNameRules: [v => !!v || 'Необходимо ввести название организации'],
      positionRules: [v => !!v || 'Необходимо ввести должность в организации'],
      personaNameRules: [v => !!v || 'Необходимо ввести имя сотрудника'],
      pinCodeRules: [
        v => !!v || 'Необходимо ввести пин-код',
        v => (v && v.length > 3) || 'Пин-код должен быть равен 4 цифрам'
      ],
      dateRules: [v => !!v || 'Необходимо ввести дату'],
      valid: true,
      selectDivision: '',
      selectLocation: '',
      selectPosition: '',
      position: '',
      menu: false,
      date: '',
      currentDivisionList: [],
      currentLocationsList: [],
      currentPositionList: [],
      divisionError: ''
    }
  },
  created() {
    this.$store.dispatch('GET_DB_ACCESS_LIST')
    this.$store.dispatch('GET_DB_LIST_FOR_NEW_EMPLOYEE')
    this.subscribeToMutations()
  },
  watch: {
    orgInn(val) {
      this.$store.state.employee.errors.organisationInfoError = ''
      if (val.length === 14 && this.$refs.orgInn.validate()) {
        this.$store.dispatch('GET_ORGANISATION_INFO', val)
        this.getDivisionsByInn(val)
        this.getLocationList()
      }
      this.$store.state.employee.organisationInfo = ''
    },
    personalInn(val) {
      this.$store.state.employee.errors.personalInfoError = ''
      if (val.length === 14 && this.$refs.personalInn.validate()) {
        this.$store.dispatch('GET_PERSONAL_INN_INFO', {
          organisationInn: this.orgInn,
          employeeInn: this.personalInn
        })
      }
      this.$store.state.employee.personalInfo = ''
    },
    isAdmin(val) {
      this.showPermissionsBlock = !val
    },
    dbList(val) {
      this.isPreloader = !val
    },
    showPersonalName(val) {
      if (val) {
        this.employeeName = val
        this.showPinCodeForm = false
        this.isEditEmployeeName = false
      }
    },
    showOrgName(val) {
      this.organisationName = val
      this.isEditOrgName = false
    },
    showLocalPin(val) {
      if (val) {
        this.showPinCodeForm = true
        if (!this.$store.state.employee.personalInfo.name) {
          if (this.personalInn === this.orgInn) {
            this.isEditEmployeeName = false
          } else {
            this.isEditEmployeeName = true
            this.employeeName = this.organisationName
          }
        }
      }
    },
    selectDivision(val) {
      if (val) {
        this.getPositionList(val)
      }
    }
  },
  computed: {
    ...mapState({
      loadingPersonalInn: state => state.employee.loading.personalInn,
      loadingOrganisationInn: state => state.employee.loading.organisationInn,
      dbList: state => state.employee.dbListForNewEmployee,
      dbAccessList: state => state.employee.dbAccessList,
      loadingBtn: state => state.employee.loading.addNewEmployee,
      showLocalPin: state => state.employee.personalInfo.showLocalPin
    }),
    showPersonalName: {
      get() {
        if (this.orgInn === this.personalInn) {
          return this.organisationName
        } else {
          return this.$store.state.employee.personalInfo.name
        }
      },
      set(val) {
        this.employeeName = val
        this.error = false
        this.errorMessage = ''
      }
    },
    showOrgName: {
      get() {
        return this.$store.state.employee.organisationInfo
      },
      set(val) {
        this.organisationName = val
        this.error = false
        this.errorMessage = ''
      }
    },
    classifierAccessList() {
      return this.$store.getters.classifierAccessList
    }
  },
  methods: {
    clearInfo() {
      this.$store.state.employee.personalInfo = ''
      this.$store.state.employee.organisationInfo = ''
      this.personalInn = ''
      this.orgInn = ''
      this.organisationName = ''
      this.employeeName = ''
      this.pinCode = ''
      this.isAlert = false
      this.alertText = ''
    },
    cancel() {
      this.$router.push({ path: '/main/employee/list' })
      this.clearInfo()
      this.$refs.form.reset()
    },
    isPermissions() {
      if (!this.isAdmin) {
        return this.dbList.map(item => {
          return { id: item.id, dbName: item.dbName, access: item.access }
        })
      } else return []
    },
    createNewEmployee() {
      if (this.$refs.form.validate()) {
        const data = {
          InnEmployee: this.personalInn,
          InnOrganisation: this.orgInn,
          PinCode: this.pinCode,
          EmployeeName: this.employeeName,
          OrganisationName: this.organisationName,
          IsAdmin: this.isAdmin,
          // organisationId: 'string',
          divisionId: this.selectDivision,
          positionId: this.selectPosition,
          appointmentDate: this.date,
          // dismissalDate: '2019-07-11T11:39:22.165Z',
          locationId: this.selectLocation,
          permissions: this.isPermissions()
        }
        this.$store.dispatch('ADD_NEW_EMPLOYEE', data).then(() => this.clearInfo())
      }
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'GET_ORGANISATION_NAME_FAILURE':
            this.isEditOrgName = state.employee.errors.organisationInfoError.status === 404
            break
          // case 'GET_PERSONAL_NAME_SUCCESS':
          //   if (this.$store.state.employee.personalInfo.showLocalPin) {
          //     // this.isEditEmployeeName = true
          //     this.showPinCodeForm = true
          //   }
          //   break
          case 'ADD_NEW_EMPLOYEE_ERROR':
            this.isAlert = true
            this.alertText = state.employee.errors.addNewEmployeeError
            break
        }
      })
    },
    getDivisionsByInn(inn) {
      axios({
        method: 'GET',
        url: `/api/Division/listFromInn/${inn}`
      })
        .then(response => {
          // console.log(response.data)
          this.currentDivisionList = response.data.result
        })
        .catch(error => {
          this.divisionError = error.response.data.message
        })
    },
    getLocationList() {
      axios({
        method: 'GET',
        url: '/api/Location/list'
      })
        .then(response => {
          // console.log(response.data)
          this.currentLocationsList = response.data.result
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    getPositionList(divisionId) {
      axios({
        method: 'GET',
        url: '/api/Position/list',
        params: { divisionId }
      })
        .then(response => {
          // console.log(response.data)
          this.currentPositionList = response.data.result
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/AddEmployee/AddEmployee.js